import { BlockWrapper } from '../Preview';
import React from "react";
import { checked, generateCss, generateEvent, generateValue } from "../../functions/sortableFunctions";

const Input = ({ block, ...props }: any) => {
    React.useEffect(() => {
        if (block?.data?.type == 'file') {
            props.setFileTypeFields((prev: any) => {
                if (block.data.multiple) {

                    return {
                        ...prev,
                        [block.data.name]: "multiple"
                    }
                } else {
                    return {
                        ...prev,
                        [block.data.name]: "single"
                    }
                }
            });

        }
    }, []);
    return (
        <React.Fragment>
            {
                React.createElement(
                    block.type,
                    {
                        id: block?.id,
                        style: {
                            fontFamily: block?.style?.fontFamily
                        },
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            },
                        }),
                        ...block.data,
                        checked: checked({
                            props: {
                                ...props,
                                block: block
                            },
                        }),
                        value: generateValue({
                            props: {
                                ...props,
                                block: block
                            },
                        }),
                        min: block?.data?.min ? typeof block.data.min == 'object' ? eval(block.data.min.value) : block.data.min : null,
                        max: block?.data?.max ? typeof block.data.max == 'object' ? eval(block.data.max.value) : block.data.max : null,
                        onChange: block.events?.onChange ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onChange"
                            });
                        } : block?.data?.type != 'file' ? (e) => {
                            props?.formik?.handleChange(e);
                        } : (e) => {
                            console.log("HereInInput", block?.data?.name, e.target.files)
                            props?.formik?.setFieldValue(block?.data?.name, e.target.files);
                        },
                        // onClick: block.events?.onClick ? async (e) => {
                        //     await generateEvent({
                        //         props: {
                        //             ...props,
                        //             block: block
                        //         },
                        //         e: e,
                        //         event: "onClick"
                        //     });
                        // } : block?.data?.type != 'file' ? (e) => {
                        //     props?.formik?.handleChange(e);
                        // } : (e: any) => {
                        //     props?.formik?.setFieldValue(block?.data?.name, e.target.files);
                        // },

                        onBlur: block.events?.onBlur ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onBlur"
                            });
                        } : (e) => {
                            props?.formik?.handleBlur(e);
                        },
                    },
                    block.children ?
                        block.children?.map((value: any, index: any) => {
                            return <BlockWrapper {...props} block={value} key={index} />;
                        })
                        :
                        null
                )
            }
        </React.Fragment>
    )
}
export default Input;